import React from 'react';
import { Building2 } from 'lucide-react';
import { DashCard, money, compactMoney } from './DashCard';

export const TopBrokersCard = ({ brokers = [] }) => {
  const total = brokers.reduce((s, b) => s + b.gross, 0) || 1;
  return (
    <DashCard title="Top Brokers" subtitle="By gross · last 30 days" icon={Building2} delay={320} testid="dashboard-top-brokers">
      {brokers.length === 0 ? (
        <div className="h-[200px] flex items-center justify-center text-sm text-slate-500 dark:text-slate-300">No loads in the last 30 days</div>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-sm uppercase tracking-wider text-slate-500 dark:text-slate-300">
              <th className="text-left font-medium pb-2">Broker</th>
              <th className="text-right font-medium pb-2">Loads</th>
              <th className="text-right font-medium pb-2">Avg</th>
              <th className="text-right font-medium pb-2">Gross</th>
            </tr>
          </thead>
          <tbody>
            {brokers.map((b, i) => (
              <tr key={b.broker_name} className="border-t border-slate-100 dark:border-slate-800 hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors" data-testid={`top-broker-${i}`}>
                <td className="py-2.5 pr-2">
                  <div className="font-medium text-slate-800 dark:text-slate-100 truncate max-w-[150px]">{b.broker_name}</div>
                  <div className="text-sm text-slate-500 dark:text-slate-300">{((b.gross / total) * 100).toFixed(0)}% of top brokers</div>
                </td>
                <td className="py-2.5 text-right font-mono">{b.loads}</td>
                <td className="py-2.5 text-right font-mono text-slate-600 dark:text-slate-300">{compactMoney(b.avg_per_load)}</td>
                <td className="py-2.5 text-right font-mono font-semibold text-blue-700 dark:text-blue-400">{money(b.gross)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DashCard>
  );
};
